import { RouteRecordRaw } from 'vue-router';

import { LAYOUTS, ROUTE_NAMES } from '@/constants';
import i18n, { loadTranslations } from '@/plugins/i18n';

import { authenticationGuard, fetchCommonData } from './guards';

const Advertising = () => import('@/pages/Advertising/Advertising.vue');
const AdvertisingCampaignForm = () => import('@/pages/Advertising/AdvertisingCampaignForm/AdvertisingCampaignForm.vue');

const fetchTranslations = async () => {
  await loadTranslations('advertising');
};

export const advertisingRoutes: RouteRecordRaw[] = [
  {
    path: '/advertising/',
    name: ROUTE_NAMES.ADVERTISING,
    component: Advertising,
    beforeEnter: [authenticationGuard, fetchCommonData, fetchTranslations],
    meta: {
      title: () => i18n.t('advertising.title'),
      description: () => i18n.t('advertising.description'),
      permissions: [
        { rules: [({ userActiveCompany }) => Boolean(userActiveCompany?.staffId && userActiveCompany.seller)] },
      ],
    },
  },
  {
    path: '/advertising/add-campaign',
    name: ROUTE_NAMES.ADVERTISING_ADD_CAMPAIGN,
    component: AdvertisingCampaignForm,
    beforeEnter: [authenticationGuard, fetchCommonData, fetchTranslations],
    meta: {
      layout: LAYOUTS.FULL,
      title: () => i18n.t('advertising.formTrackingTitle'),
      permissions: [
        { rules: [({ userActiveCompany }) => Boolean(userActiveCompany?.staffId && userActiveCompany.seller)] },
      ],
    },
  },
];

export default advertisingRoutes;
